import { render } from "./scan_total.vue?vue&type=template&id=4c9d8b63&scoped=true"
import script from "./scan_total.vue?vue&type=script&lang=js"
export * from "./scan_total.vue?vue&type=script&lang=js"

import "./scan_total.vue?vue&type=style&index=0&id=4c9d8b63&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c9d8b63"]])

export default __exports__